import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const BarChart = ({ chartData, seriesName = 'Registered Users' }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = echarts.init(chartRef.current);

    const maxDataValue = chartData && chartData.datasets && chartData.datasets.length > 0
      ? Math.max(...chartData.datasets[0].data)
      : 0;
    const interval = Math.ceil(maxDataValue / 5);

    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      // toolbox: {
      //   feature: {
      //     saveAsImage: {}
      //   }
      // },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: chartData.labels,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          min: 0,
          interval: interval
        }
      ],
      series: [
        {
          name: seriesName,
          type: 'bar',
          barWidth: '70%',
          barMinWidth: 10, // Set a minimum bar width
          itemStyle: {
            color: getComputedStyle(document.documentElement).getPropertyValue('--ansa-dash-blue-lighter').trim()
          },
          data: chartData && chartData.datasets && chartData.datasets.length > 0 ? chartData.datasets[0].data : []
        }
      ]
    };

    chartInstance.setOption(option);

    return () => {
      chartInstance.dispose();
    };
  }, [chartData, seriesName]);

  return <div ref={chartRef} style={{ width: '700px', height: '500px', margin: "5px auto" }} />;
};

export default BarChart;